import { z } from 'zod';
import { PART_CONSTRAINTS } from './constraints.js';
export const clonePartFormSchema = z.object({
    num: z
        .string()
        .trim()
        .min(1, `${PART_CONSTRAINTS.num.label} is required.`)
        .max(PART_CONSTRAINTS.num.maxLength),
    name: z.string().max(PART_CONSTRAINTS.name.maxLength),
    copyVendors: z.boolean(),
    copyStockSetup: z.boolean(),
    copyCosting: z.boolean(),
    copySpecifications: z.boolean(),
});
//# sourceMappingURL=clone-form.js.map